var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-footer"
  }, [_c('content-wrapper', [_c('div', {
    staticClass: "bottom-wrapper"
  }, [_c('div', {
    staticClass: "bottom-wrapper-part"
  }, [_c('article', {
    staticClass: "bottom-part part-logo"
  }, [_c('img', {
    staticClass: "main-logo",
    attrs: {
      "src": require("./page-logo/modus.png"),
      "alt": "logo",
      "width": "192",
      "heigth": "21"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam viverra euismod odio, gravida pellentesque urna varius vitae. Sed dui lorem, adipiscing in adipiscing et, interdum nec.")]), _vm._v(" "), _c('ul', {
    staticClass: "part-phone"
  }, [_c('li', {
    staticClass: "part-phone-list"
  }, [_vm._v("Phone:")]), _vm._v(" "), _c('li', {
    staticClass: "part-phone-list"
  }, [_vm._v("182 2569 5896")])]), _vm._v(" "), _c('ul', {
    staticClass: "part-mail"
  }, [_c('li', {
    staticClass: "part-phone-mail "
  }, [_vm._v("e-mail:")]), _vm._v(" "), _c('li', {
    staticClass: "part-phone-mail"
  }, [_vm._v("info@modu.versus")])])]), _vm._v(" "), _c('article', {
    staticClass: "bottom-part part-list"
  }, [_c('ul', {
    staticClass: "part-bottom-list part-company"
  }, [_c('h3', {
    staticClass: "company-menu"
  }, [_vm._v("Company")]), _vm._v(" "), _c('ul', {
    staticClass: "bottom-menu-list"
  }, [_c('li', {
    staticClass: "tant-list"
  }, [_vm._v("About")]), _vm._v(" "), _c('li', {
    staticClass: "tant-list"
  }, [_vm._v("FAQ")]), _vm._v(" "), _c('li', {
    staticClass: "tant-list"
  }, [_vm._v("Contact")]), _vm._v(" "), _c('li', {
    staticClass: "tant-list"
  }, [_vm._v("Terms")]), _vm._v(" "), _c('li', {
    staticClass: "tant-list"
  }, [_vm._v("Privacy")]), _vm._v(" "), _c('li', {
    staticClass: "tant-list"
  }, [_vm._v("Testimonials")])])]), _vm._v(" "), _c('ul', {
    staticClass: "part-bottom-list part-community"
  }, [_c('h3', {
    staticClass: "community-menu"
  }, [_vm._v("Community")]), _vm._v(" "), _c('ul', {
    staticClass: "bottom-menu-list"
  }, [_c('li', {
    staticClass: "tant-list list-left"
  }, [_vm._v("Blog")]), _vm._v(" "), _c('li', {
    staticClass: "tant-list list-left"
  }, [_vm._v("Forum")]), _vm._v(" "), _c('li', {
    staticClass: "tant-list list-left"
  }, [_vm._v("Support")]), _vm._v(" "), _c('li', {
    staticClass: "tant-list list-left"
  }, [_vm._v("Newsletter")])])])]), _vm._v(" "), _c('article', {
    staticClass: "bottom-part part-blog"
  }, [_c('div', {
    staticClass: "imageblog"
  }, [_c('div', {
    staticClass: "member"
  }, [_c('ul', {
    staticClass: "blog-from"
  }, [_c('li', {
    staticClass: "part-from from"
  }, [_vm._v("from the")]), _vm._v(" "), _c('li', {
    staticClass: "part-from blog"
  }, [_vm._v("BLOG")])]), _vm._v(" "), _c('table', [_c('tr', [_c('td', {
    staticClass: "figure",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('img', {
    staticClass: "left-img ",
    attrs: {
      "src": require("./page-png/foto.png"),
      "alt": "",
      "width": "70",
      "heigth": "70"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "blog-text"
  }, [_vm._v("\n                                         Lorem ipsum dolor sit amet, consectetur adipiscing elit\n                                         ")]), _vm._v(" "), _c('td', {
    staticClass: "figure part-none",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('img', {
    staticClass: "left-img ",
    attrs: {
      "src": require("./page-png/foto.png"),
      "alt": "",
      "width": "70",
      "heigth": "70"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "blog-text part-none"
  }, [_vm._v("\n                                         Lorem ipsum dolor sit amet, consectetur adipiscing elit\n                                         ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "blog-data"
  }, [_vm._v("\n                                             26 May, 2013\n                                         ")]), _vm._v(" "), _c('td', {
    staticClass: "blog-data part-none"
  }, [_vm._v("\n                                             26 May, 2013\n                                         ")])]), _vm._v(" "), _c('tr', {
    staticClass: "margin-image"
  }), _vm._v(" "), _c('tr', {
    staticClass: "part-bottom-none"
  }, [_c('td', {
    staticClass: "figure",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('img', {
    staticClass: "left-img ",
    attrs: {
      "src": require("./page-png/foto.png"),
      "alt": "",
      "width": "70",
      "heigth": "70"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "blog-text"
  }, [_vm._v("\n                                         Lorem ipsum dolor sit amet, consectetur adipiscing elit\n                                         ")]), _vm._v(" "), _c('td', {
    staticClass: "figure part-none",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('img', {
    staticClass: "left-img ",
    attrs: {
      "src": require("./page-png/foto.png"),
      "alt": "",
      "width": "70",
      "heigth": "70"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "blog-text part-none"
  }, [_vm._v("\n                                         Lorem ipsum dolor sit amet, consectetur adipiscing elit\n                                         ")])]), _vm._v(" "), _c('tr', {
    staticClass: "part-bottom-none"
  }, [_c('td', {
    staticClass: "blog-data"
  }, [_vm._v("\n                                             26 May, 2013\n                                         ")]), _vm._v(" "), _c('td', {
    staticClass: "blog-data part-none"
  }, [_vm._v("\n                                             26 May, 2013\n                                         ")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-bottom-line"
  }, [_c('content-wrapper', [_c('div', {
    staticClass: "modus-versus"
  }, [_vm._v("2013  ModusVersus")]), _vm._v(" "), _c('nav', {
    staticClass: "fa-go-tw-rs"
  }, [_c('a', {
    attrs: {
      "href": "",
      "alt": "facebook"
    }
  }, [_c('span', {
    staticClass: "facebook"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "",
      "alt": "google"
    }
  }, [_c('span', {
    staticClass: "google"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "",
      "alt": "twitter"
    }
  }, [_c('span', {
    staticClass: "twitter"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "",
      "alt": "rss"
    }
  }, [_c('span', {
    staticClass: "rss"
  })])])])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65c199e5","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/extract-loader/lib/extractLoader.js!./node_modules/html-loader?{"interpolate":true,"attrs":[":url","link:href","source:src"]}!./src/components/page-footer/page-footer.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-65c199e5","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/extract-loader/lib/extractLoader.js!./node_modules/html-loader/index.js?{"interpolate":true,"attrs":[":url","link:href","source:src"]}!./src/components/page-footer/page-footer.vue
// module chunks = index